export const snippet =
`import React from 'react';
import { ReQuartzCron, ReUnixCron, Tab } from '@sbzen/re-cron';

const App = () => (
  <ReQuartzCron tabs={[Tab.MINUTES, Tab.HOURS]}/>
  // or <ReUnixCron tabs={[Tab.MINUTES, Tab.HOURS]}/>
);
export default App;`;
